import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useMemo, useState } from 'react';

import Search from '../../../../vehicle/search';
import CompleteList from '../../complete-list';
import FilteredList from '../../filtered-list';
import SearchInput from '../../search-input';
import { modelAtom } from '../../../../../../hooks/use-picker-selection';
import { useAtom } from 'jotai';

type ModelListProps = {
  models: TResultAPICarsBySlug;
  displayList?: boolean;
  displayInput?: boolean;
  numberOfColumns?: number;
  searchInput?: any;
  customClickFunction?: boolean;
  noResultsLink?: boolean;
};

const ModelList = ({
  models,
  displayList = false,
  displayInput = true,
  numberOfColumns = 1,
  searchInput,
  customClickFunction = false,
  noResultsLink = true,
}: ModelListProps) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');

  const filteredModels = useMemo(
    () => Search(search, models.children),
    [search, models]
  );

  useEffect(() => setSearch(searchInput), [searchInput]);

  return (
    <>
      <div
        className={cx(
          'container mx-auto mb-12 overflow-visible',
          displayList ? 'px-4' : 'lg:my-14 max-lg:px-4 mt-4'
        )}
        id="scroll_to_search_models"
      >
        {displayInput && (
          <div className="w-full mx-auto max-lg:pt-0 lg:p-0 lg:my-12 sticky top-0 bg-white z-10 overflow-visible">
            <SearchInput
              search={search}
              placeholder={t('vehicle:models.searchByModelOrYear')}
              setSearch={setSearch}
              isFullWith={true}
              targetId="scroll_to_search_models"
            />
          </div>
        )}
        <div className="">
          {search ? (
            <FilteredList
              values={filteredModels}
              displayList={displayList}
              numberOfColumns={numberOfColumns}
              customClickFunction={customClickFunction}
              listType={'MODELS'}
              noResultsLink={noResultsLink}
            />
          ) : (
            <CompleteList
              values={filteredModels}
              displayList={displayList}
              numberOfColumns={numberOfColumns}
              customClickFunction={customClickFunction}
              listType={'MODELS'}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ModelList;
